import Packery from 'packery';
import getSize from 'get-size/get-size';

/* eslint-disable */
Packery.prototype._setRectSize = function (elem, rect) {
  const size = getSize(elem);
  let w = size.outerWidth;
  let h = size.outerHeight;
  // size for columnWidth and rowHeight, if available
  const colW = this.columnWidth + this.gutter;
  const rowH = this.rowHeight + this.gutter;
  w = this.columnWidth ? Math.round(w / colW) * colW : w + this.gutter;
  h = this.rowHeight ? Math.round(h / rowH) * rowH : h + this.gutter;
  // rect must fit in packer
  rect.width = Math.min(w, this.packer.width);
  rect.height = h;
};
/* eslint-enable */

export default Packery;
